export default {
  refills: (state) => state.refills,
  refill: (state) => (id) => state.refills.filter((item) => item.id == id)[0],
  cart: (state) => state.cart,
  cartLocal: (state) => state.localCart?.items,
  fibToken: (state) => state.fibToken,
};
